import { USE_MOCK } from '@/lib/api/env';
import { getRealtimeClient } from '@/lib/realtime';
import type { ChatApi } from './contract';
import { httpChatApi } from './httpChatApi';
import { mockChatApi } from './mock/mockChatApi';
import { createMockRealtime } from './realtime/mockClient';
import type { RealtimeClient } from './realtime/types';

/**
 * ═══════════════════ THE SWITCH ═══════════════════
 * LIVE by default — apps/api :3021 and apps/gateway :3022.
 * `VITE_USE_MOCK=true` puts the whole feature back on fixtures for an offline
 * demo. Both implementations satisfy the same `ChatApi` / `RealtimeClient`
 * contracts, which come straight from `@cyphex/types` and docs/API.md.
 */
export const chatApi: ChatApi = USE_MOCK ? mockChatApi : httpChatApi;

let mockRealtime: RealtimeClient | null = null;

/** One socket per tab — never one per conversation. */
export function getRealtime(): RealtimeClient {
  if (!USE_MOCK) return getRealtimeClient();
  if (mockRealtime === null) mockRealtime = createMockRealtime();
  return mockRealtime;
}

export { ApiRequestError as ChatApiError } from '@/lib/api/errors';
export { setAccessToken } from '@/lib/api/token';
export type { ChatApi } from './contract';
export type { ConnectionState, RealtimeClient, RealtimeDelivery } from './realtime/types';
